module.exports = __webpack_public_path__ + "img/w-explore-friend.2823c47d.svg";